module.exports = __webpack_public_path__ + "static/img/1.4694e7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/zh/1.png
// module id = nRmN
// module chunks = 0